import { barrasCode128, QUIET_ZONE_MODULOS } from '../lib/barcode';

// O código de barras desenhado como SVG inline.
//
// SVG e não <img>: a CSP do sistema é `img-src 'self' data:`, e um data-URI
// funcionaria — mas SVG inline usa `currentColor`, então o código herda a cor
// do tema (preto no papel, branco na tela escura) sem ninguém gerar duas
// versões. E não há requisição nenhuma.
//
// `shapeRendering="crispEdges"` desliga o antialias: barra com borda borrada é
// o que faz o leitor hesitar, principalmente quando a etiqueta é impressa e
// depois binarizada em preto e branco.

export default function CodigoBarras({
  valor, alturaPx = 56, moduloPx = 2, mostrarTexto = true, className = '',
}: {
  valor: string;
  /** Altura só das barras. O texto embaixo, quando houver, soma à altura total. */
  alturaPx?: number;
  /** Largura do módulo mais fino. Abaixo de 2px o leitor começa a errar. */
  moduloPx?: number;
  mostrarTexto?: boolean;
  className?: string;
}) {
  let desenho;
  try {
    desenho = barrasCode128(valor);
  } catch {
    // SKU com acento ou vazio não vira barra — mas também não pode derrubar a
    // ficha da peça. Mostra o texto e segue.
    return <p className={`font-mono text-xs text-dim ${className}`}>{valor}</p>;
  }

  const { barras, larguraModulos } = desenho;
  const totalModulos = larguraModulos + QUIET_ZONE_MODULOS * 2;
  const alturaTexto = mostrarTexto ? 14 : 0;

  return (
    <svg
      className={className}
      // O viewBox trabalha em MÓDULOS; a largura em px multiplica. Assim o
      // desenho escala sem nenhuma barra cair em meio pixel.
      viewBox={`0 0 ${totalModulos} ${alturaPx + alturaTexto}`}
      width={totalModulos * moduloPx}
      height={alturaPx + alturaTexto}
      role="img"
      aria-label={`Código de barras: ${valor}`}
      shapeRendering="crispEdges"
    >
      {barras.map((b) => (
        <rect
          key={b.x}
          x={b.x + QUIET_ZONE_MODULOS}
          y={0}
          width={b.largura}
          height={alturaPx}
          fill="currentColor"
        />
      ))}
      {mostrarTexto && (
        <text
          x={totalModulos / 2}
          y={alturaPx + 11}
          textAnchor="middle"
          fontSize={11}
          fontFamily="monospace"
          letterSpacing={1}
          fill="currentColor"
        >
          {valor}
        </text>
      )}
    </svg>
  );
}
